import { func_print } from "../Func_genericas/func_print";
import { get } from "../Services/tokenConfig";

export const getCabecalhosEficiencia = async (id_identificacao: number, token: string) => {

    try {
        // setIsLoading(true);
        let res = await get(token, `/get_Grupos_Homogeneos_id_rosto/${id_identificacao}`);

        // setIsLoading(false);
        return res.data.result

    } catch (error) {
        func_print("getCabecalho", error, true);
        // setIsLoading(false);
        return [];
    }
}